<template lang="pug">
div.newsentry.w-flex.wrap(
  :style="{width,backgroundColor,flexDirection: (imageLeft) ? 'row-reverse' : ''}"
)
  div.column.newsentry-content.w-flex.justify-center.align-center
    h1.news-title.text-center {{newsTitle}}
    div.news-date(
      v-if="newsDate != ''"
    ) 
      w-icon.mr2(
        style="cursor:pointer;"
        color="black"
      ) mdi mdi-calendar-clock
      | {{newsDate}}
    div.news-date(
      v-else
    )
      p &nbsp;
    span.news-content(
      v-if="newsContent != ''"
      ref="newsPreview"
      :class="{'news-content-preview': !readMore}")
      | {{newsContent}}
    span.news-content(
      v-else
      ref="newsPreview"
      :class="{'news-content-preview': !readMore}")
        slot
    div.news-content-readmore(
      v-if="!readMore && isOverflowing"
      @click="readMore=!readMore")
      w-icon(
            style="font-size: 40px"
            color="black"
            title="Ganzen Text anzeigen"
            xl
          ) mdi mdi-chevron-down
      | alles anzeigen
      w-icon(
            style="font-size: 40px"
            color="black"
            title="Ganzen Text anzeigen"
            xl
          ) mdi mdi-chevron-down
  div.column.newsentry-image.w-flex.justify-center.align-center
    router-link(v-if="imageRoute" :to="imageRoute")
      w-image.newsentry-image(
        tag="img"
        :src="image"
        :width="imgWidth"
        :height="imgHeight"
        contain
      )
    w-image.newsentry-image(
      v-else
      tag="img"
      :src="image"
      :width="imgWidth"
      :height="imgHeight"
      contain
    )
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'NewsEntry',
  data() {
    return {
      readMore: false,
      isMounted: false,
      isOverflowing: false
    }
  },
  props: {
    backgroundColor: {
      type: String,
      required: false,
      default: "lightblue",
      note: 'CSS background-color'
    },
    image: {
      type: String,
      required: true,
      note: 'Image src'
    },
    width: {
      type: String,
      required: false,
      default: '100%',
      note: 'CSS width'
    },
    height: {
      type: String,
      required: false,
      default: 'auto',
      note: 'CSS height'
    },
    imgWidth: {
      type: String,
      required: false,
      default: '100%',
      note: 'CSS image width'
    },
    imgHeight: {
      type: String,
      required: false,
      default: '100%',
      note: 'CSS image height'
    },
    ratio: {
      type: Number,
      required: false,
      default: 0.5,
      note: 'The width ratio'
    },
    imageRoute: {
      type: Object,
      required: false,
      default: undefined,
      note: 'Image route'
    },
    imageLeft: {
      type: Boolean,
      required: false,
      default: false,
      note: 'Show the image on the left side'
    },
    newsTitle:{
      type: String,
      required: true,
      note: 'News title'
    },
    newsDate:{
      type: String,
      required: false,
      note: 'News date',
      default: ''
    },
    newsContent:{
      type: String,
      required: false,
      note: 'News content',
      default: ''
    },
  },
  computed: {
    ...mapGetters('global',{
      portrait: 'portrait',
      showMenu: 'showMenu',
      viewport: 'viewport',
    })
  },
  methods: {
    checkOverflowing() {
      if(!this.isMounted)
        return;
      var element = this.$refs.newsPreview;
      if (element)
        return (element.offsetHeight < element.scrollHeight || element.offsetWidth < element.scrollWidth)
      else
        return false
    }
  },
  components: {
  },
  watch: {
    viewport() {
      this.isOverflowing = this.checkOverflowing()
    },
  },
  mounted(){
    this.isMounted = true;
    this.isOverflowing = this.checkOverflowing()
  }
}
</script>

<style lang="scss">
.newsentry {
  .newsentry-image {
    .w-image {
      background-position: center;
    }
  }
  .column{
    flex-basis: 300px;
    flex-grow: 1;
    padding: 20px;
  }
  .news-date {
    font-size: 12px;
  }
  .news-content{
    text-align: justify; 
    white-space: pre-line;
  }
  .news-content-preview{
    max-height: min(40vw, 245px);
    overflow: hidden;
    position: relative;
    text-align: justify; 
    white-space: pre-line;
  }
  .news-content-preview:after {
    position: absolute;
    bottom: 0;  
    height: 100%;
    width: 100%;
    content: "";
    pointer-events: none; /* so the text is still selectable */
  }
  .news-content-readmore {
    text-align: center;
    width: 100%;
    cursor: pointer;
  }
}
</style>